export interface SolutionsMenu {
  id: number;
  advisors: boolean;
  courses: boolean;
  services: boolean;
  plans: boolean;
}

export interface SideMenu {
  id: number;
  contact_info: boolean;
  coins: boolean;
  timer: boolean;
  solutions: SolutionsMenu;
}

export interface SolutionMenuItem {
  id: string;
  label: string;
  path: string;
  icon: string;
  isActive: boolean;
}

export const SOLUTIONS_MENU_ITEMS = {
  advisors: {
    id: 'advisors',
    label: 'Assessores',
    path: '/solutions/advisors',
    icon: 'person',
    isActive: false,
  },
  courses: {
    id: 'courses',
    label: 'Cursos',
    path: '/solutions/courses',
    icon: 'school',
    isActive: false,
  },
  services: {
    id: 'services',
    label: 'Serviços',
    path: '/solutions/services',
    icon: 'handshake',
    isActive: false,
  },
  plans: {
    id: 'plans',
    label: 'Planos',
    path: '/solutions/plans',
    icon: 'card_membership',
    isActive: false,
  },
} as const;
